import { PropsWithChildren } from 'react';
import { cn } from '@anytag/shared-utils';
import { CircularProgress, CircularProgressProps } from './CircularProgress';

export type LoadingProps = CircularProgressProps;

export const Loading = ({ className, children, ...restProps }: PropsWithChildren<LoadingProps>) => (
  <div
    className={cn(
      'relative z-3 flex h-screen w-full flex-col items-center justify-center rounded-[inherit] bg-inherit',
      className
    )}
  >
    <CircularProgress size={64} thickness={1.3} className="bg-black-30" {...restProps} />
    {children}
  </div>
);
